import { DataFromUrl, ScoreCard, handleOtherResponseCode, SUCCESS_REPONSE_CODE,
         UNPROCESSABLE_ENTITY_RESPONSE_CODE, REDIRECT, startDateMessage, CustomToastrAction, INITIAL_VALUES, CommonAction, scorecard_config_initials, job_competency_initials } from  '@/imports-files/pages/clients/jobs/scorecards';


  export function getSuggestionValue(suggestion) {
    return suggestion.label;
  }
  export function renderSuggestion(suggestion) {
    return (
      <span>{suggestion.label}</span>
    );
  }

  export async function onSuggestionsFetchRequested(value, setCompetencies, router){
    let competencies = await getSuggestions(value, router)
    return setCompetencies(competencies);
  };

  export const onSuggestionsClearRequested = (setCompetencies) => {
    setCompetencies([])
  };


  export function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  export async function getSuggestions(value, router) {
    const escapedValue = escapeRegexCharacters(value.trim());
    let competencies_list = await getCompetenciesList(escapedValue, router)
    return competencies_list
  }

  export function shouldRenderSuggestions(value){
    // return value.trim().length >= 3
    return true
  }

  export function onAddClick(...args){
    const formik             = args[0];
    const action             = args[1];
    const setCompetencyCount = args[2];
    const index              = args[3];
    let competencies_names   = formik.values.job_competency_names
    if(action == "add")
    {
      competencies_names.push('')
    }
    else
    {
      competencies_names.splice(index,1)
    }
    setCompetencyCount(competencies_names.length)
  }


  export async function getCompetenciesList(name, router){
    const body                =   {name: name }
    const result              =   await new ScoreCard().getCompetencyByName(body);
    const status_code         =   result.status || result.response.status;
    const customToastrAction  =   new CustomToastrAction();
    switch (status_code)
    {
      case SUCCESS_REPONSE_CODE:
                                  const response = result.data;
                                  return response.competencies || []
      case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
                                  customToastrAction.setNormalToastr(result.response.data.error, 'warning');
                                  // toastr.warning(result.response.data.error)
                                  return [];
      default:
      handleOtherResponseCode(status_code, router);
    }
  }

export async function handleCompentencyFormSubmit(params, router, setPageName, queryClient, current_step, fromKanban, gotoKanban, setDisabledSaveButton, formRef)
{
    // TODO
    setDisabledSaveButton(true);
    const body          =   {step: current_step, job: {} }
    body['job']['step'] = current_step;
    setParamsValues({formRef: formRef});
    params.scorecard_config_attributes ? body['job']['scorecard_config_attributes'] = params.scorecard_config_attributes : ''; 
    params.job_competencies_attributes ? body['job']['job_competencies_attributes'] = params.job_competencies_attributes : ''; 
    
    var job_id                =   window.location.pathname.split('/').slice(-2)[0];
    var job_id                =   new DataFromUrl().getJobId();
    const result              =   await new ScoreCard().addCompetencies(body, job_id );
    const status_code         =   result.status || result.response.status;
    const customToastrAction  =   new CustomToastrAction();

    switch (status_code)
    {
      case SUCCESS_REPONSE_CODE:
      const response = result.data;
      let queryPath = fromKanban ? "?from_kanban=true" : ""
      if(gotoKanban)
      {
        if(fromKanban){
          router.push({pathname: REDIRECT.client.kanban_board.replace('$job_id', job_id)});
        }
        else{
          router.push({ pathname: REDIRECT.client.jobs.index, query: { job_type: 'active' } });
        }
      }
      else
        { router.push(REDIRECT.client.jobs.job_sharing.replace('$job_id', job_id)+queryPath); }

      // goToNextPage('job-sharing', setPageName, queryClient, REDIRECT.client.jobs.job_sharing.replace('$job_id', job_id));
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      let message = "";
      if(result.response.data.error.job?.start_date) { message = startDateMessage(message, result.response.data.error.job?.start_date)}
      if(message.length > 0)
      {
        customToastrAction.setNormalToastr(message, 'warning');
        // toastr.warning(message)
      }
      setDisabledSaveButton(false);
      break;
    default:
      handleOtherResponseCode(status_code, router);
      setDisabledSaveButton(false);
    }

  }


  export async function getScorecardData(setApiError)
  {
      // var job_id              =   window.location.pathname.split('/').slice(-2)[0];
      var job_id              =   new DataFromUrl().getJobId();
      const scorecard_data    =   await new ScoreCard().getCompetencies(job_id);
      if(scorecard_data.request.status == 200){
        const result            =   scorecard_data.data.job;
        const data              =   {
                                      props: {
                                                result
                                            }
                                    }
        return data;
      }
      else{
        setApiError(scorecard_data.request)
      }

  }


    // This funtion set the values of the params which are not filled by the fields 
  // /constants/pages/clients/jobs/scorecards.js

  //pass job_id
  export function setParamsValues(params)
  {
    
      // params.formRef.current.values.scorecard_config_attributes.job_id = params.job_id;


      // If the add a scorecard link is selected then just sent the scorecard_config_attributes
      // and delete others 
      if(params.formRef.current?.values.scorecard_config_attributes.link && params.formRef.current.values.job_competencies_attributes)
      {
          for(let job_competencies_attributes of params.formRef.current.values.job_competencies_attributes)
          {
               job_competencies_attributes._destroy = true;
          }
      } 
      else if(params.formRef.current?.values.scorecard_config_attributes.link && !params.formRef.current.values.job_competencies_attributes)
      {
          delete params.formRef.current.values.job_competencies_attributes;
      }
      else if( !params.formRef.current?.values.scorecard_config_attributes.link && params.formRef.current.values.scorecard_config_attributes)
      {
          params.formRef.current.values.scorecard_config_attributes.link = false;
          params.formRef.current.values.scorecard_config_attributes.scorecard_link = '';
      }
      else if( !params.formRef.current?.values.scorecard_config_attributes.link && !params.formRef.current.values.scorecard_config_attributes)
      {
          delete params.formRef.current.values.scorecard_config_attributes;
      }
      /*----------------------------------job_sub_competencies_attributes ---------------------------------- */
  }

export class ScorecardAction
{
  constructor(formRef, initialValues, setFlagForRender)
  {
      this.commonAction = new CommonAction();
      this.formRef = formRef;
      this.initialValues = initialValues;
      this.setFlagForRender = setFlagForRender
  }

  getInitialValue(values)
  {
    INITIAL_VALUES.scorecard_config_attributes = values?.scorecard_config_attributes || scorecard_config_initials();
    INITIAL_VALUES.job_competencies_attributes = values?.job_competencies_attributes || [job_competency_initials()]
    // if(INITIAL_VALUES.job_competencies_attributes.length == 0) INITIAL_VALUES.job_competencies_attributes =  [job_competency_initials()];
    return INITIAL_VALUES;
  }


  //TODO change it to the single select for radio and checkbox
  selectScorecardType(select_scorecard_name, event, value, initial_values)
  {
     if(select_scorecard_name)
     {
       // this.formRef.current.setFieldValue('job_competencies_attributes',[]);
       // this.formRef.current.setFieldValue('scorecard_config_attributes.instructions','');
       // this.formRef.current.setFieldValue('scorecard_config_attributes.private', false);
       // this.formRef.current.setFieldValue('scorecard_config_attributes.scorecard_link','');
       this.formRef.current.setValues(this.getInitialValue(initial_values));
       this.formRef.current.setFieldValue(select_scorecard_name, value);
       this.formRef.current.setFieldTouched('job_competencies_attributes',false);
       this.formRef.current.setFieldTouched('scorecard_config_attributes.scorecard_link',false);
     }
  }

  selectPrivateScorecard(select_name, event)
  {
    this.formRef.current.setFieldValue(select_name, event.target.checked);
  }
  //-------------------------------------------



  showScorecardTypeComponent(type, formik)
  {
        let value = false;
        switch (type) {
        case 'select_create_scorecard':   let create_scorecard_value = !formik?.values.scorecard_config_attributes.link
                                          if(create_scorecard_value)
                                          {
                                            value = create_scorecard_value;
                                          }
                                          if(typeof create_scorecard_value == 'undefined')
                                          {
                                            value = true;
                                          }
                                          break;
        case 'select_add_scorecard_link': let add_scorecard_link_value = formik.values.scorecard_config_attributes.link
                                          if(add_scorecard_link_value)
                                          {
                                             value = add_scorecard_link_value;
                                          }
                                          if(typeof add_scorecard_link_value == 'undefined')
                                          {
                                            value = false;
                                          }
                                          break;
        default: '';
      }

      return value;
  }


}
